import React, { Suspense } from "react";
import { Navigate, RouteObject } from "react-router-dom";

import Error from "../../../Components/UI-KIT/Error";
import noAuthRoutesPaths from "./noAuth.routesPaths";
import { RegistrationPage } from "../../../Pages/Registration.page";
import { AuthorizationPage } from "../../../Pages/Authorization.page";
import { PasswordRecoveryEmailPage } from "../../../Pages/PasswordRecoveryEmail.page";
import { routeBuilder } from "../../services/routeBuilder.service";
import CheckNoAuth from "../../services/Components/CheckNoAuth";
import { PasswordRecoveryEmailSuccessPage } from "../../../Pages/PasswordRecoveryEmailSuccess.page";
import NoAuthLayout from "../../../Layouts/NoAuth.layout";
import Loader from "../../../Components/UI-KIT/Loader";
import { PasswordRecoveryPasswordPage } from "../../../Pages/PasswordRecoveryPassword.page";
import { RefRegistrationPage } from "../../../Pages/RefRegistration.page";
import { VerifyEmailPage } from "src/user.InterfaceLayer/Pages/VerifyEmail.page";

const noAuthRoutes: RouteObject[] = [
	{
		element: <CheckNoAuth />,
		errorElement: <Error />,
		children: [
			{
				element: <NoAuthLayout />,
				children: [
					{
						path: noAuthRoutesPaths.REGISTRATION,
						element: (
							<Suspense>
								<RegistrationPage />
							</Suspense>
						),
						errorElement: <Error />,
					},
					{
						path: noAuthRoutesPaths.VERIFY_EMAIL,
						element: (
							<Suspense>
								<VerifyEmailPage />
							</Suspense>
						),
						errorElement: <Error />,
					},
					{
						path: noAuthRoutesPaths.REF_REGISTRATION + "/:id",
						element: (
							<Suspense>
								<RefRegistrationPage />
							</Suspense>
						),
						errorElement: <Error />,
					},

					{
						path: noAuthRoutesPaths.AUTHORIZATION,
						element: (
							<Suspense>
								<AuthorizationPage />
							</Suspense>
						),
						errorElement: <Error />,
					},
					{
						path: noAuthRoutesPaths.PASSWORD_RECOVERY_EMAIL,
						element: (
							<Suspense>
								<PasswordRecoveryEmailPage />
							</Suspense>
						),
						errorElement: <Error />,
					},
					{
						index: true,
						path: noAuthRoutesPaths.PASSWORD_RECOVERY_PASSWORD + "/:id",
						element: (
							<Suspense fallback={<Loader />}>
								<PasswordRecoveryPasswordPage />
							</Suspense>
						),
						errorElement: <Error />,
					},
					{
						path: "",
						element: (
							<Navigate to={routeBuilder([noAuthRoutesPaths.AUTHORIZATION])} />
						),
						errorElement: <Error />,
					},
				],
			},
		],
	},
];

export default noAuthRoutes;
